import React from 'react';
import { useValueChange } from '@leverege/ui-hooks';
import { Pane, Checkbox } from '@leverege/ui-elements';
import Model from './Model';
import { jsx as _jsx } from "react/jsx-runtime";
function GeoLayerEditor(props) {
  const {
    value
  } = props;
  const onModelChange = useValueChange(Model, props);
  return /*#__PURE__*/_jsx(Pane, {
    variant: "editor",
    children: /*#__PURE__*/_jsx(Checkbox, {
      label: "Visible",
      eventData: "setVisible",
      value: Model.getVisible(value),
      onChange: onModelChange
    })
  });
}
export default /*#__PURE__*/React.memo(GeoLayerEditor);